module.exports = __webpack_public_path__ + "images/fd5728f2cf777b06b966d05c0c823dc9.svg";